











































































































































































































































































import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch
} from '@vue/composition-api'
import VMap from '@/components/VMap.vue'
import VControls from '@/components/VControls.vue'
import { useStore } from '@/store'

export default defineComponent({
  name: 'Home',

  components: {
    VMap,
    VControls
  },

  props: {
    debug: {
      type: Boolean,
      default: false
    }
  },

  setup(props) {
    const {
      state,
      activeRoute,
      askLocationPermissions,
      checkDistance,
      startRoute
    } = useStore()

    const introStep = ref(1)

    const showIntro = computed(() => {
      return !state.locationAccess
    })

    const pickRoute = (routeId: string) => {
      state.activeRouteId = routeId
      introStep.value = 2
    }

    const startRouteAndClosePopover = (routeId: string) => {
      introStep.value = 1
      startRoute(routeId)
    }

    onMounted(() => {
      if (props.debug) {
        state.debugging = true
      }
    })

    watch(introStep, () => {
      const content = document.querySelector('.c-popover--open')
      if (content) {
        content.scrollTop = 0
      }
    })

    return {
      state,
      activeRoute,
      introStep,
      showIntro,
      pickRoute,
      askLocationPermissions,
      checkDistance,
      startRoute,
      startRouteAndClosePopover
    }
  }
})
